module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/024-honduras-ab9bb747c2bab4102304afbe630fabe4.svg";